import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import BrandIntroSection from './components/BrandIntroSection';
import NewBooks2026Section from './components/NewBooks2026Section';
import PublishingDirectionsSection from './components/PublishingDirectionsSection';
import ChannelSection from './components/ChannelSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <BrandIntroSection />
        <NewBooks2026Section />
        <PublishingDirectionsSection />
        <ChannelSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}